import { GroupDTO } from "../../types";
import { fetchRefreshIntegrated, fetchWithOkCheck, getBaseUrl } from "../api.utils";

export const getGroupExistsById = async (id: string) =>
    await (await fetchWithOkCheck(`${await getBaseUrl("groups")}/exists/${id}`)).json();

export const getCurrentGroup = async (groupId: string) => await fetchRefreshIntegrated<GroupDTO>(`${await getBaseUrl("groups")}/${groupId}`);
